<template>
  <div class="registered-body">
    <div>
      <div v-if="!userInfo" class="registered-title">
        <strong>场景开放创新平台账号申请</strong>
        <p>已有账号？<span @click="login">登录</span></p>
      </div>
      <div v-else class="registered-title">
        <strong>场景开放创新平台账号完善</strong>
        <p>
          欢迎:{{ userInfo.email || userInfo.phone
          }}<span @click="logout">退出</span>
        </p>
      </div>
      <div class="registered-steps">
        <a-steps :current="steps">
          <a-step title="账号信息"></a-step>
          <a-step title="身份类型"></a-step>
          <a-step title="完善资料"></a-step>
          <a-step title="注册完成"></a-step>
        </a-steps>
      </div>
      <div class="registered-content-body">
        <account-info v-show="steps === 0" @success="steps = 1" />
        <identity
          v-show="steps === 1"
          @next="chooseIdentity"
          @pre="steps = 0"
        />
        <write-info
          v-show="steps === 2"
          :type="companyType"
          @next="steps = 3"
          @pre="steps = 1"
        />
        <success v-show="steps === 3" />
      </div>
      <!-- <div class="registered-footer">
        <p>
          Copyright © 2013-2021 北京掌中无限信息技术有限公司 京公网安备
          11010802028637号
        </p>
        <p>京ICP证041626号 | 京ICP备09083730号-8</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import AccountInfo from "./modules/AccountInfo.vue";
import Identity from "./modules/Identity.vue";
import writeInfo from "./writeInfo.vue";
import success from "./success.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AccountInfo,
    Identity,
    writeInfo,
    success,
  },
  data() {
    return {
      steps: 0,
      companyType: 1, //0政府 1企业
      supplementInfoData: "",
    };
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    chooseIdentity(val) {
      this.steps = 2;
      this.companyType = val;
    },
    login() {
      this.$router.push("/login");
    },
    logout() {
      this.$store.dispatch("Logout");
    },
  },
  mounted() {
    if (!this.userInfo) {
      this.steps = 0;
    } else if (!this.userInfo.companyId) {
      this.steps = 1;
    } else {
      this.steps = 3;
    }
  },
};
</script>

<style lang="less" scoped>
.registered-body {
  background: #f6f8fb;
  height: 100%;
  overflow-y: auto;

  > div {
    width: 1200px;
    margin: 0 auto;
    padding-top: 100px;

    .registered-title {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;

      > strong {
        font-size: 34px;
        line-height: 34px;
      }

      > p {
        font-size: 14px;
        line-height: 14px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -7px;
        color: #8c8c8c;

        > span {
          color: #1abc9c;
          cursor: pointer;
          z-index: 2;
        }
      }
    }

    .registered-content-body {
      height: 680px;
      background: #ffffff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      margin-top: 40px;
    }

    .registered-footer {
      padding: 24px 0;
      margin-top: 60px;
      text-align: center;
      color: #bfbfbf;

      > p {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
}
</style>
<style>
.registered-steps .ant-steps-item-process .ant-steps-item-icon {
  background: #1abc9c;
  border-color: #1abc9c;
}

.registered-steps .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #1abc9c;
}

.registered-steps
  .ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title::after {
  background-color: #1abc9c;
}

.registered-steps
  .ant-steps-item-finish
  .ant-steps-item-icon
  > .ant-steps-icon {
  color: #1abc9c;
}
</style>
